import React, { useEffect, useState } from 'react'
import { CustomModal } from 'components'
import dayjs from 'dayjs'
import axiosInstance from 'utils/axiosConfig'
import { toastError } from 'utils/toastify'
import { errorMessage } from 'constant/const'
import { isVideoUrl } from 'utils/isImageOrVideo'
import { createImageUrl } from 'utils/createImageUrl'

function BatchPostAnalysisModal({ isOpenNewVideoModal, onClose }) {
   const [loading, setLoading] = useState(false)
   const [videoData, setVideoData] = useState([])
   const [count, setCount] = useState(0)
   const [currentPage, setCurrentPage] = useState(1)
   const perPage = 10

   useEffect(() => {
      if (isOpenNewVideoModal) {
         fetchBatchData(currentPage)
      }
   }, [isOpenNewVideoModal, currentPage])

   const fetchBatchData = async (page = 1) => {
      try {
         setLoading(true)
         const response = await axiosInstance.get('instagram/get_batch_analysis_list')
         setVideoData(response.data?.data || [])
         setCount(response.data?.count || 0)
      } catch (error) {
         toastError(errorMessage)
         console.error('Error fetching batch analysis:', error)
         setVideoData([])
      } finally {
         setLoading(false)
      }
   }

   return (
      <CustomModal
         show={isOpenNewVideoModal}
         title={'Batch Analysis Status'}
         closeModal={onClose}
         size={'xl'}
         scrollable
         centered>
         <div className="pt-0 batch-table">
            <table className="table table-hover">
               <thead>
                  <tr>
                     <th>#</th>
                     <th>Batch ID</th>
                     <th>Profile name</th>
                     <th>Post Count</th>
                     <th>Post image</th>
                     <th>Date</th>
                     <th>Status</th>
                  </tr>
               </thead>
               <tbody>
                  {loading ? (
                     <tr>
                        <td colSpan="7" className="text-center py-4">
                           Loading...
                        </td>
                     </tr>
                  ) : videoData?.length > 0 ? (
                     videoData?.map((item, index) => (
                        <tr key={index}>
                           <th scope="row">{(currentPage - 1) * perPage + index + 1}</th>
                           <td>{item?.batch_id}</td>
                           <td>{item?.profile_username}</td>
                           <td>{item?.post_count}</td>
                           <td>
                              <ul className="mb-0 ps-3 post-image-wrap-modal">
                                 {item.posts.map((post, idx) => (
                                    <li key={idx} className="mb-1">
                                       {isVideoUrl(post?.thumbnail_url) ? (
                                          <video
                                             src={createImageUrl(post?.thumbnail_url)}
                                             autoPlay={false}
                                             style={{
                                                width: '100px',
                                                height: '100px',
                                                objectFit: 'contain'
                                             }}
                                          />
                                       ) : (
                                          <img
                                             src={createImageUrl(post?.thumbnail_url)}
                                             alt="InPostImage"
                                             className="mw-100"
                                             style={{
                                                width: '100px',
                                                height: '100px',
                                                objectFit: 'contain'
                                             }}
                                          />
                                       )}
                                       {/* <img src={create} /> */}
                                    </li>
                                 ))}
                              </ul>
                           </td>
                           <td>{dayjs(item?.created_at).format('DD MMM YYYY')}</td>
                           <td className="text-capitalize">{item?.status}</td>
                        </tr>
                     ))
                  ) : (
                     <tr>
                        <td colSpan="7" className="text-center py-4">
                           No data available
                        </td>
                     </tr>
                  )}
               </tbody>
            </table>

            {!loading && count > perPage && (
               <Pagination
                  currentPage={currentPage}
                  totalCount={count}
                  perPage={perPage}
                  onPageChange={(page) => setCurrentPage(page)}
               />
            )}
         </div>
      </CustomModal>
   )
}

export default BatchPostAnalysisModal

// ---------------- Pagination Component ----------------
const Pagination = ({ currentPage, totalCount, perPage, onPageChange }) => {
   const totalPages = Math.ceil(totalCount / perPage)

   const generatePages = () => {
      const pages = []

      if (totalPages <= 6) {
         for (let i = 1; i <= totalPages; i++) pages.push(i)
      } else {
         pages.push(1)
         if (currentPage > 3) pages.push('...')
         const start = Math.max(2, currentPage - 1)
         const end = Math.min(totalPages - 1, currentPage + 1)

         for (let i = start; i <= end; i++) pages.push(i)

         if (currentPage < totalPages - 2) pages.push('...')
         pages.push(totalPages)
      }

      return pages
   }

   return (
      <div className="pagination-wrapper">
         <div>
            <button
               onClick={() => onPageChange(currentPage - 1)}
               disabled={currentPage === 1}
               className="page-btn">
               &lt;
            </button>
         </div>

         <div className="page-item">
            {generatePages().map((page, idx) => (
               <button
                  key={idx}
                  onClick={() => typeof page === 'number' && onPageChange(page)}
                  disabled={page === '...'}
                  className={`page-btn ${currentPage === page ? 'active' : ''}`}>
                  {page}
               </button>
            ))}
         </div>

         <div>
            <button
               onClick={() => onPageChange(currentPage + 1)}
               disabled={currentPage === totalPages}
               className="page-btn">
               &gt;
            </button>
         </div>
      </div>
   )
}
